module.exports = "<ion-icon mode=\"md\" tappable (click)=\"shareTicket()\" name=\"share\"></ion-icon>"